import {Asset} from '@deviceinsight/ng-ui-api-client';
import {getAxios} from '@deviceinsight/ng-ui-api-client';
import {ACTION_TYPE_DEVICE, BLINKING_FREQUENCY, DEVICE_ACTION_TYPE} from '../modules/ruleengine/config/consts';

const syncLed = (
	asset: Asset,
	dataPoint: string,
	color: string | null | undefined = '#FFFFFF',
	targetFrequency: number = BLINKING_FREQUENCY
) => {
	const {urn, id} = asset;
	const action = {
		actionType: ACTION_TYPE_DEVICE,
		deviceActionType: DEVICE_ACTION_TYPE.SET_LED,
		targetValue: color,
		targetFrequency,
		dataAddress: {
			assetUrn: urn,
			assetId: id,
			dataPoint
		}
	};
	return getAxios().post(`/rafi/v1/actions/syncLed/${encodeURIComponent(urn)}`, action);
};

export {syncLed};
